import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../services/api.service';
import { CommonService } from '../services/common.service';
import { PopoverController, LoadingController, MenuController } from '@ionic/angular';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { AuthService } from '../services/auth.service';
import { TranslationService } from '../services/translation.service';

@Component({
  selector: 'app-inviteuser',
  templateUrl: './inviteuser.page.html',
  styleUrls: ['./inviteuser.page.scss'],
})
export class InviteuserPage implements OnInit {

  tokenId: any = ''
  locale: any = ''

  constructor(private router: Router, private route: ActivatedRoute,  public ngxSmartModalService: NgxSmartModalService ,
    public loadingController: LoadingController,
    private _authService: AuthService,
    public _commonService: CommonService,
    private _apiService: ApiService,
    private menuController: MenuController,
    private _translationService: TranslationService) { }

  ngOnInit() {
  }

 
  ionViewWillEnter(){
   
    this._commonService.isLoggedIn = false
  }


  async ionViewDidEnter(){
    this.tokenId = this.route.snapshot.paramMap.get('id');
    if (localStorage.locale) {
      this._commonService.locale = Number(localStorage.locale);
      this.locale = Number(localStorage.locale);
    } else {
      this._commonService.locale = 1043;
      localStorage.locale = this._commonService.locale;
    }

    await this.getLocales();
    this.inviteUser();
  }

  async getLocales() {
    try {
      if (!localStorage.domainLocales || localStorage == undefined) {
        let response = await this._apiService.getInviteUserDomainLocales(this.tokenId);
        localStorage.domainLocales = JSON.stringify(response.body);
      }
    } catch (error) {
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  async inviteUser(){
    this._commonService.presentLoading();
    try {
      let res = await this._apiService.veriftUserInviteEmail(this.tokenId);
      console.log(res);
      if(res.ExistingUser){
        if (Number(res.DefaultPassword)) {
          let locale = localStorage.locale;
          localStorage.clear();
          sessionStorage.clear();
          localStorage.locale = locale;
          localStorage.domainName = 'master'; //f.value.domain.trim();
          this._commonService.tempUserName = res.UserName.trim();
          this._commonService.tempDomainName = 'master'; //f.value.domain.trim();
          this._commonService.tempAuthKey = res.AuthenticationKey;
          this._commonService.tempDefaultPassword = true;
          this._commonService.dismiss();
          this.router.navigate(['/resetdefaultpassword']);
        }
        else{
          if (res.OTPVerification) {
            this._commonService.tempUserName = res.UserName.trim();
            this._commonService.tempDomainName = 'master'; //f.value.domain.trim();
            if(res.SecretKey){
              this._commonService.secretKey = res.SecretKey 
              this._commonService.showQrScanner = true
            }else{
              this._commonService.showQrScanner = false
            }
            
            this._commonService.dismiss();
            this.router.navigate(['/loginverification']);
          }
          else {

            let currentTime = new Date();
            localStorage.sessionStartTime = currentTime.getHours();
            localStorage.setItem('userId', res.UserId);
            localStorage.setItem('userName', res.UserName);
            localStorage.setItem('firstName', res.FirstName);
            localStorage.setItem('domainLocales', JSON.stringify(res.Locales));
            localStorage.setItem('menuItems', JSON.stringify(res.MenuItems));
            localStorage.setItem('domainName', res.DomainName);
            localStorage.setItem('domainId', res.DomainId);
            localStorage.setItem('roleCode', res.RoleCode);
            localStorage.setItem('authenticationKey', res.AuthenticationKey);
            localStorage.setItem('folderEntryAllowed', res.FolderEntryAllowed);
            localStorage.setItem('linkedToMultipleDomains', res.LinkedToMultipleDomains);
            localStorage.setItem('MaxAllowedCompanyPerDomain', res.MaxAllowedCompanyPerDomain);
            localStorage.setItem('helpImageChangeInterval', res.HelpImageChangeInterval);
            localStorage.setItem('notificationsUnreadCount', res.NotificationsUnreadCount ? res.NotificationsUnreadCount : 0);
            localStorage.setItem('Datecreated', res.Datecreated ? res.Datecreated : '');
            localStorage.setItem('FirstLogin', res.FirstLogin ? res.FirstLogin : 'false');
            localStorage.setItem('TeamLeaderGuid',res.TeamLeaderGuid);
            localStorage.setItem('locale',res.DefaultLocale?res.DefaultLocale:1043);
            this.locale = res.DefaultLocale?res.DefaultLocale:1043;
            
            this._commonService.notificationsUnreadCount = res.NotificationsUnreadCount ? res.NotificationsUnreadCount : 0

            if (res.Companies) localStorage.setItem('companies', JSON.stringify(res.Companies));
            localStorage.setItem('userRoles', res.UserRoles ? JSON.stringify(res.UserRoles) : null);
           

            this._commonService.domainLocales = res.Locales;

            this._commonService.linkedToMultipleDomains = res.LinkedToMultipleDomains

            if (res.CustomerLogo) {
              this._commonService.customerLogo = 'data:image/png;base64,' + res.CustomerLogo;
              localStorage.setItem('customerLogo', 'data:image/png;base64,' + res.CustomerLogo);
            } else {
              this._commonService.customerLogo = null;
              localStorage.removeItem('customerLogo');
            }

            if (res.RoleCode == 'UserRole_CustomerAdmin') {
              this._commonService.isCustomerAdmin = true
            }
            if (res.RoleCode == 'UserRole_CustomerUser') {
              this._commonService.isCustomerUser = true
            }
            if (res.RoleCode == 'UserRole_Support') {
              this._commonService.isSupportUser = true
            }
            if (res.RoleCode == 'UserRole_Legal') {
              this._commonService.isJuristUser = true
            }


            if (localStorage.currentImage) {
              localStorage.removeItem('currentImage')
            }

            if (localStorage.helpDetail) {
              localStorage.removeItem('helpDetail')
            }
       

            if (res.Locales.length == 1) {
              this._commonService.locale = res.Locales[0].LocaleId;
              localStorage.locale = res.Locales[0].LocaleId;
            }
            this._commonService.menuItems = res.MenuItems;
            this._commonService.domainName = res.DomainName;

            this._commonService.domain = {
              DomainId: res.DomainId,
              Name: res.DomainName
            }
            this._commonService.dismiss();

            this._translationService.getTranslation(this.locale);

           this.router.navigate(['/dashboard']);

            this._commonService.isLoggedIn = true;
            localStorage.domains = res.LinkedDomains ? JSON.stringify(res.LinkedDomains) : null;
            this._commonService.getFAQS();
            try {
              let moduleList = await this._apiService.getModules('', '', '', 1, 0);
              localStorage.moduleList = JSON.stringify(moduleList.body);

            } catch (error) {
              localStorage.sessionStartTime = "";
              this._commonService.dismiss();
              this._commonService.log(error, this._commonService.ERROR);
            }
            try {
              let settingList = await this._apiService.getSettings('', '', '', 1, 0);
              settingList.body.forEach((value, index) => {
             
                if (value.SettingName == "Force2FactorAuthentication") {
                  localStorage.Force2FactorAuthentication = value.SettingValue;
                }
                if (value.SettingName == "TeamleaderTags") {
                  localStorage.TeamleaderTags = value.SettingValue;
                }

              })
             
            } catch (error) {
              this._commonService.dismiss();
              this._commonService.log(error, this._commonService.ERROR);
            }
          }
        }
      }else{
        sessionStorage.invitedUserFirstName = res.FirstName,
        sessionStorage.invitedUserName = res.EmailAddress,
        sessionStorage.secretKey = res.SecretKey
        this.router.navigate(['/profile/' +  this.tokenId]);
        this._commonService.dismiss();
      }
     
    } catch (error) {
      if(error.status == 422){
        this._commonService.dismiss();
        this._commonService.clearData();
      
        this.router.navigate(['/login'], { replaceUrl: true });
      }else{
        this._commonService.clearData();
      
        this.router.navigate(['/login'], { replaceUrl: true });
        this._commonService.dismiss();
      }
     
    }
  }



}
